import React from 'react';
// Components
import Sales from 'components/common/Sales';

const ContentCreatorStoreSales: React.FC = () => {
  return <Sales />;
};

export default ContentCreatorStoreSales;
